import IacLenderScreen from './IacLenderScreen';
export default IacLenderScreen;
